import React from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';
import './Footer.css';

function Footer({ children }) {
  const urlWithQuery = "";
  let pixelUrl = config.pixelBaseUrl + '&url=' + encodeURIComponent(urlWithQuery);

  const utmElements = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  utmElements.forEach(element => {
    const value = localStorage.getItem(element);
    if (value !== null) {
      pixelUrl = pixelUrl + "&" + element + "=" + value;
    }
  });

  return (
    <footer className="site-footer">
      <div className="footer-content">
        {children}
        <div className="footer-links">
          <a
            href="https://tethyst.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Built by Tethyst
          </a>
          <span className="footer-divider">|</span>
          <Link to="/privacy-policy" className="footer-link">
            Privacy
          </Link>
          <span className="footer-divider">|</span>
          <Link to="/terms-of-service" className="footer-link">
            Terms
          </Link>
        </div>
      </div>
      <img src={pixelUrl} alt="" className="tracking-pixel" />
    </footer>
  );
}

export default Footer;
